export default __webpack_public_path__ + "static/media/edit.e331b331.svg";